<template>
  <div class="container" />
</template>
<script>
import { mapActions,mapGetters } from "vuex";
import browserSignature from 'browser-signature';
const signature = browserSignature();

export default {

  data() {
    return {
      nonce: this.$route.query.nonce ?? ''
    };
  },
  computed: {
    ...mapGetters(["isSSOLogin", "user"])
  },

  watch: {
    user: function () {
      if (this.user != 'undefined') {
        this.setUser()
      }
    },
  },

  mounted() {
    const loginFailed = this.$route.query.login_failed ?? 0

    if (!this.isSSOLogin && loginFailed == '0') {
      this.onSSOLogin()
    } else if (loginFailed == '1') {

    } else {
      if (this.user != 'undefined') {
         this.setUser()
      }
    }
  },

  methods: {
    ...mapActions(["setSSOLogin"]),
    onSSOLogin() {
      this.setSSOLogin({
        nonce: this.nonce,
        device_type: "web",
        device_token: signature,
        timestamp: (new Date()).getTime()
      });
    },

    setUser() {
      let redirect_to = this.$route.query?.redirect_to ?? 'dashboard'
      let oldUser = JSON.parse(localStorage.getItem('user'))
      if (oldUser) {
        let msg = `You are logged in as ${oldUser?.user?.full_name ?? 'user'}. Continue to end this session and access ${this.user?.user?.full_name ?? 'user'}’s account.`
        this.$confirmDialog.show({
          title: "Confirmation",
          text: msg,
          onConfirm: () => {
            localStorage.setItem('user', JSON.stringify(this.user))
            localStorage.setItem('isSilentLogin', true)
            if (redirect_to == 'dashboard') {
              this.$router.push({ name: "dashboard" })
            }
          },
          onClose: () => {
            if (redirect_to == 'dashboard') {
              this.$router.push({ name: "dashboard" })
            }
          }
        });
      } else {
        localStorage.setItem('user', JSON.stringify(this.user))
        localStorage.setItem('isSilentLogin', true)
        if (redirect_to == 'dashboard') {
          this.$router.push({ name: "dashboard" })
        }
      }
    }
  },
};
</script>
